import api from "@/services/api";
import { getAuthEndpoint } from "@/helpers/roleHelper"; // Gunakan dari roleHelper.js

// Layanan untuk login
export const login = async (credentials) => {
  try {
    const endpoint = getAuthEndpoint();
    console.log("Using auth endpoint:", endpoint); // Debug log
    const response = await api.post(`${endpoint}/login`, credentials);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Login failed");
  }
};

// Layanan untuk forgot password
export const forgotPassword = async (email) => {
  try {
    const endpoint = getAuthEndpoint();
    const response = await api.post(`${endpoint}/forgot-password`, {
      email,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Forgot password failed");
  }
};

// Layanan untuk mendapatkan profil pengguna
export const getProfile = async () => {
  try {
    const endpoint = getAuthEndpoint();
    const response = await api.get(`${endpoint}/me`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch profile");
  }
};

// Layanan untuk mengubah profil pengguna
export const updateProfile = async (profileData) => {
  try {
    const endpoint = getAuthEndpoint();
    const response = await api.put(`${endpoint}/change-profile`, profileData);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update profile"
    );
  }
};

// Layanan untuk mengubah password pengguna
export const changePassword = async (passwordData) => {
  try {
    const endpoint = getAuthEndpoint();
    const response = await api.put(`${endpoint}/change-password`, passwordData);
    return response.data;
  } catch (error) {
    console.error("Password change error details:", error.response?.data);
    if (error.response && error.response.data) {
      throw error;
    }
    throw new Error("Failed to change password");
  }
};

export const resetPassword = async (
  token,
  newPassword,
  passwordConfirmation
) => {
  try {
    const endpoint = getAuthEndpoint();
    const response = await api.post(
      `${endpoint}/reset-password`,
      {
        newPassword,
        passwordConfirmation,
      },
      {
        params: { token },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Reset password error details:", error.response?.data);
    if (error.response && error.response.data) {
      throw error;
    }
    throw new Error("Failed to reset password");
  }
};

export const logout = async () => {
  try {
    const endpoint = getAuthEndpoint();
    const response = await api.post(`${endpoint}/logout`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Logout failed");
  }
};
